import React from 'react';
import { ScrollView } from 'react-native-gesture-handler';

import { LoadingAnimation, useResponsive } from '@sg/garnish';

import { useContentfulContentTypeEntry } from '@order/Contentful';
import { HomeV2, useHomeContent, type HomeContent, getBannerContent } from '@order/features-home';

import { useIsLoggedIn } from '../../../../context/AuthMachine';

export const HomeScreenContentV2 = () => {
  const isLoggedIn = useIsLoggedIn();
  const { currentBreakpoint } = useResponsive();

  // ─── Content ───────────────────────────────────────────────────────────────

  const contentfulEntry = useContentfulContentTypeEntry<HomeContent>({ contentType: 'homeScreen' });
  const content = useHomeContent(contentfulEntry?.data?.fields);
  const isLoadingContent = contentfulEntry?.fetching;
  const bannerContent = getBannerContent(content, isLoggedIn, currentBreakpoint.isXS);

  // ───────────────────────────────────────────────────────────────────────────

  if (isLoadingContent) {
    return <LoadingAnimation />;
  }

  return (
    <ScrollView>
      <HomeV2.Banner size={isLoggedIn ? 'small' : 'large'} content={bannerContent} />
    </ScrollView>
  );
};
